import { billing } from '@saucelabs/sl-util-axios';

export const preview = (params) => billing.post('/checkout/preview', params);

export const purchase = (params) => billing.post('/checkout/purchase', params);
